var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('thermo-map',{attrs:{"access-token":"pk.eyJ1IjoibWhvZmJhdWVyIiwiYSI6ImNpbmlvOW9zYTAwM3R3MmtsdzQzNmlhaHQifQ.U68SeYBseY3_lMpr7fY3Sg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }